import { Component, OnInit } from '@angular/core';
import { ReferenceDataLabels } from 'rome-library';
import { HeaderService } from '../../../core/services/header.service';
import { TaggingService } from '../../../tag-manager';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'boi-session-closed',
  templateUrl: './session-closed.page.html'
})
export class SessionClosedPage implements OnInit {
  public readonly referenceDataLabels = ReferenceDataLabels;
  constructor(
    private readonly taggingService: TaggingService,
    private readonly headerService: HeaderService,
    private readonly loginService: LoginService
  ) {
    this.taggingService.resetDataLayer();
    this.taggingService.execute();
    this.headerService.resetHeaderTitle();
  }

  ngOnInit(): void {
    this.loginService.resetAuthenticatedUser();
  }
}
